import { render, staticRenderFns } from "./IconLeft.vue?vue&type=template&id=3ddfced5&scoped=true&"
import script from "./IconLeft.vue?vue&type=script&lang=js&"
export * from "./IconLeft.vue?vue&type=script&lang=js&"
import style0 from "./IconLeft.vue?vue&type=style&index=0&id=3ddfced5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddfced5",
  null
  
)

export default component.exports